<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
            <p class="header-title"> {{$t('job_management.title')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center" class="pr-5">
            <v-row class="d-flex justify-end">
              <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col >
                              <v-autocomplete v-model="selectCategory" :items="categories" item-text="title" v-bind:label="$t('job_management.role')" :disabled="editedIndex > -1" return-object></v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-row v-show="selectCategory.type !== 5">
                          <v-col >
                            <v-autocomplete v-model="selectContext" :items="contexts" item-text="name" v-bind:label="$t('job_management.context')" return-object></v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col>
                            <v-text-field v-model="editedItem.title" :rules="stringRules" v-bind:label="$t('job_management.name')"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col>
                            <v-text-field v-model="editedItem.description" v-bind:label="$t('job_management.description')"></v-text-field>
                          </v-col>
                        </v-row>         
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" dark @click="close">{{ $t('common.cancel')}}</v-btn>
                      <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                    </v-card-actions>
                  </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" sort-by="email" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
          <template v-slot:top>
            <v-toolbar flat color="white" class="pt-5">
              <v-row justify="start">
                  <v-col cols="12" sm="1">
                    <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined dense></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="2">
                    
                  </v-col>

                  <v-col cols="12" sm="2">
                  </v-col>
                
                  <v-col cols="12" sm="7">
                    <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
                  </v-col>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:[`item.action`]="{ item }">
              <v-icon  small class="mr-2"  @click="editItem(item)">
                  edit
              </v-icon>
              <v-icon  small @click="deleteItem(item)">
                  delete
              </v-icon>

          </template>

          <template v-slot:[`item.context`]="{ item }">
              <span>{{getNameJob(item.context)}}</span>

          </template>

          <template v-slot:[`item.category`]="{ item }">
              <span>{{ item.category.title }}</span>

          </template>

          <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      selectCategory: {},
      selectContext: {},

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('job_management.name'), value: 'title' },
        { text: i18n.t('job_management.description'), sortable: false, value: 'description' },
        { text: i18n.t('job_management.category'), sortable: false, value: 'category' },
        { text: i18n.t('job_management.context'), sortable: false, value: 'context' },
        { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: { 
      },
      stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
          v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ],
      categories: [],
      contexts:[],
      blocks:[],
      departments:[],
      teams:[]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('job_management.add') : i18n.t('job_management.edit')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      selectCategory(val) {
        if (this.editedIndex > -1) {
          return;
        }
        this.createContextByRole(val)      
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        await this.getData(),
        await this.getAllBlock(),
        await this.getAllDepartment(),
        await this.getAllTeam(),
        await this.getAllCategory(),
        await this.createContextByRole(this.selectCategory)
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.selectCategory = item.category;
        this.createContextByRole(this.selectCategory)
        this.selectContext = Object.assign({}, item.context);
        this.dialog = true
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete("/job/" + item._id);
          if(response.data && response.data.success) {
              // console.log(response.data);
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if (response.data && !response.data.success) {
              alert(response.data.message);
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        const self = this;

        if (this.editedIndex > -1) {
          try { 
            const requestBody =  self.editedItem;
            requestBody.context = self.selectContext._id;
            requestBody.category = self.selectCategory._id; 

            const response = await self.$http.put('/job/' + self.editedItem._id,  requestBody);

            if (response.data && response.data.success) {
                // console.log(response.data);
                self.editedItem.context = self.selectContext;
                self.editedItem.category = self.selectCategory;

                Object.assign(self.desserts[self.editedIndex], self.editedItem);
                self.editedItem = {};

                self.$fire({
                  title: i18n.t('common.update_success'),
                  text: "",
                  type: "success"
                  }).then(() => {                       
                });
            } else if (response.data && !response.data.success) {
              alert(response.data.message);
            } else {
              alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
          }
        } else {
          try {
            const requestBody = self.editedItem;
            
            requestBody.category = self.selectCategory._id; 
            if (self.selectCategory.type !== 5) {
              requestBody.context = self.selectContext._id;
            }

            const response = await self.$http.post('/job', requestBody);

            // console.log(response);
            if (response.data && response.data.success) {
              self.editedItem._id = response.data.data.id;    
              if (self.selectCategory.type !== 5) {
                  self.editedItem.context = self.selectContext;   
              }  
              
              self.editedItem.index = self.desserts.length + 1;
              self.editedItem.category = self.selectCategory; 

              
              self.desserts.push(self.editedItem);

              
              self.editedItem = {};

              self.$fire({
                  title: i18n.t('common.success'),
                  text: "",
                  type: "success"
                  }).then(() => {    
              });
            } else if (response.data && !response.data.success) {
              alert(response.data.message);
            } else {
              alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
          }
        }
        this.close()
      },

      async getData() {
        try {
            const response = await this.$http.get('/job');
            if (response.data && response.data.success) {
              // console.log(response.data);
              const contextArr = response.data.data;
              contextArr.forEach((item, index) =>item.index = index + 1);

              this.desserts = contextArr;
              this.loading = false;
            }
        } catch (e) {
            console.log(e.stack);
        }
      },
    

      async getAllTeam() {
        try {
            const response = await this.$http.get(process.env.VUE_APP_GET_TEAM_URL);
            if (response.data && response.data.success) {
              const contextArr = response.data.data;
              contextArr.forEach((item, index) => item.index = index + 1);

              this.teams = contextArr;
            }
        } catch (e) {
            //TODO add alert / flash service to Vue => Like Toast in Android

            //Only print stack trace if development
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      },

      async getAllDepartment() {
        try {
            const response = await this.$http.get(process.env.VUE_APP_GET_DEPARTMENT_URL);
            if (response.data && response.data.success) {
                const contextArr = response.data.data;
                contextArr.forEach((item, index) => item.index = index + 1);

                this.departments = contextArr;
            }
        } catch (e) {
            //TODO add alert / flash service to Vue => Like Toast in Android

            //Only print stack trace if development
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      },

      async getAllBlock() {
        try {
            const response =  await this.$http.get(process.env.VUE_APP_GET_BLOCK_URL);
            if(response.data && response.data.success) {
                const contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);

                this.blocks = contextArr;
            }
        } catch(e) {
            //TODO add alert / flash service to Vue => Like Toast in Android

            //Only print stack trace if development
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      },

      async createContextByRole(category) {
        if (category.type == 1 || category.type == 2 ) {
          this.contexts = this.teams;
        } else if (category.type == 3) {
          this.contexts = this.departments;
        } else if (category.type == 4) {
          this.contexts = this.blocks;

        } else if (category.type == 5) {
          this.contexts = [];
        }

        if (this.contexts.length > 0) {
          this.selectContext = this.contexts[0];
        }
      },

      getNameJob(context) {
        if (context) {
          if (context.parents && context.parents.length == 0) {
            return context.name;
          } else if (context.parents && context.parents.length == 1) {
            return context.parents[0].name + "/" + context.name;
          } else if (context.parents && context.parents.length == 2) {
            return context.parents[0].name + "/" + context.parents[1].name  + "/" + context.name;
          } else {
            return '';
          }
        } else {
            return '';
        }
      },

      async getAllCategory() {
        try {
            const response =  await this.$http.get('/job/categories/0');
            if(response.data && response.data.success) {
                this.categories = response.data.data;

                if (Array.isArray(this.categories) && this.categories.length > 0) {
                  this.selectCategory = this.categories[0];
                }
            }
        } catch(e) {
            //TODO add alert / flash service to Vue => Like Toast in Android

            //Only print stack trace if development
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      }
    },
  }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>